import { FaReact } from "react-icons/fa";

export const projectsData = [
  {
    id: 1,
    projectName: "Full-Stack-App",
    projectDesc:
      "An e-commerce application from where users can purchase products of their daily use like clothes, shoes etc. It has home page, product, product specific category page, cart, login,register page.",
    tags: ["React", "Redux", "Node.js", "MongoDb"],
    logos: [
      "FaReact",
      "SiRedux",
      "FaNodeJs",
      "DiMongodb",
      "SiExpress",
      "SiMaterialui",
    ],
    code: "https://github.com/rishianand39/full-stack-application",
    demo: "http://full-stack-application.vercel.app/",
    image:
      "https://user-images.githubusercontent.com/97423069/170484549-122c1cb9-e0c1-4226-92e7-dff9f3ac6c23.png",
  },
  {
    id: 2,
    projectName: "Social_media_app",
    projectDesc:
      "This application is a way to connect people around you and around the globe. You can login/register, can create any post. You can see posts of people , you can like/dislike them.",
    tags: ["React", "Redux", "Node.js", "MongoDb"],
    logos: [
      "FaReact",
      "SiRedux",
      "FaNodeJs",
      "DiMongodb",
      "SiExpress",
      "SiMaterialui",
    ],
    code: "https://github.com/rishianand39/social_media_app",
    demo: "https://social-media-app-smoky.vercel.app/",
    image:
      "https://user-images.githubusercontent.com/97423069/179274394-edf94c34-5370-44cc-bc14-29bedcd457e4.png",
  },
  {
    id: 3,
    projectName: "YouTube",
    projectDesc:
      "A video-sharing platform used to watch videos from all around the world. This application is dominant all across globe. Search any type of video like entertainment, song, cricket, movie, news etc.",
    tags: ["javascript", "Html", "css"],
    logos: [
      "SiJavascript",
      "FaHtml5",
      "FaCss3",
    ],
    code: "https://github.com/rishianand39/YouTube",
    demo: "https://friendly-swirles-867fbd.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/97423069/170486129-fc726615-64a2-4790-8aeb-bd3c0602fb1e.png",
  },
  {
    id: 4,
    projectName: "Movie App",
    projectDesc:
      "A movie application to see Trending movies, movies, tv Series. Trending movies and tv series on home page. Special category for movie , tv series. Manual search is also available.",
    tags: ["React", "Redux", "Material-ui"],
    logos: [
      "FaReact",
      "SiMaterialui"
    ],
    code: "https://github.com/rishianand39/movie_application",
    demo: "https://stunning-genie-643390.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/97423069/170487181-8c6ad191-cbea-4946-9868-d44b5673b605.png",
  },
  {
    id: 5,
    projectName: "Skinstore.com Clone",
    projectDesc:
      "An e-commerce website used to buy skincare products. For each type of product special category available. Dominant in the United States. ",
    tags: ["Html", "css", "javascript","mongodb","nodejs","expressjs"],
    logos: [
      "SiJavascript",
      "FaHtml5",
      "FaCss3",
      "SiExpress",
      "FaNodeJs",
      "DiMongodb",
    ],
    code: "https://github.com/rishianand39/SkinStore-Projecte",
    demo: "https://keen-lolly-681dd2.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/97423069/170492874-5ca95998-c62d-4467-898b-d13a3b34609d.png",
  },
];

//schema for entwreing data
/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
